import { PortfolioReportDTO } from './api/usePortfolioReportsQuery';

export interface ReportOption extends PortfolioReportDTO {
  label: string;
  value: string;
}

export enum ReportFormatsDTO {
  PDF,
  Excel,
}
